import { Toaster as Sonner, toast, type ToasterProps } from 'sonner'

/**
 * App-wide notifications. Mount <Toaster /> ONCE in App.tsx, then call
 * toast.success('...') / toast.error('...') from anywhere.
 *
 * The colours come from the same tokens as everything else, so the toast
 * follows the light/dark theme without being told about it.
 */
const Toaster = (props: ToasterProps) => (
  <Sonner
    className="toaster group"
    style={{
      '--normal-bg': 'var(--popover)',
      '--normal-text': 'var(--popover-foreground)',
      '--normal-border': 'var(--border)',
    } as React.CSSProperties}
    {...props}
  />
)

export { Toaster, toast }
